let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k49zw")).then(() => parcelRequire('2TUNQ'));